type ConsentChoice = 'granted' | 'denied';

const pushToDataLayer = (data: Record<string, unknown>) => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
};

const toChoice = (allowed: boolean): ConsentChoice =>
  allowed ? 'granted' : 'denied';

export const createGTMHandler = () => ({
  onConsent: (consent: {
    analytics: boolean;
    marketing: boolean;
    performance: boolean;
  }) => {
    pushToDataLayer({
      event: 'consent_update',
      consent_analytics: toChoice(consent.analytics),
      consent_marketing: toChoice(consent.marketing),
      consent_performance: toChoice(consent.performance),
    });
  },
  track: (event: { name: string; payload?: Record<string, unknown> }) => {
    pushToDataLayer({
      event: event.name,
      ...event.payload,
    });
  },
  pageview: (event: {
    url: string;
    title?: string;
    payload?: Record<string, unknown>;
  }) => {
    pushToDataLayer({
      event: 'page_view',
      page_location: event.url,
      page_title: event.title,
      ...event.payload,
    });
  },
  identify: (event: {
    user: Record<string, unknown>;
    traits?: Record<string, unknown>;
  }) => {
    pushToDataLayer({
      event: 'identify',
      user: event.user,
      traits: event.traits,
    });
  },
});
